import { generatePath, matchPath } from 'react-router-dom';
import { memoize } from 'lodash/function';
import { router } from '%app/js/common/services/router';

class RouteResolver {
    constructor(routeTree) {
        this.routes = this.flatten(routeTree);
        this.doGenerateRouteLink = memoize(
            (id, params) => {
                const route = this.findRouteById(id);
                return generatePath(route.path, params);
            },
            (id, params) => `${id}_${JSON.stringify(params)}`,
        );
    }

    flatten(routes) {
        return routes.reduce((accumulator, route) => {
            return {
                ...accumulator,
                [route.id]: route,
                ...(route.subRoutes ? this.flatten(route.subRoutes) : []),
            };
        }, {});
    }

    findRouteById(id) {
        if (this.routes[id] === undefined) {
            throw Error(`No route with id: ${id} exists`);
        }

        return this.routes[id];
    }

    generateRouteLink(id, params = {}) {
        return this.doGenerateRouteLink(id, params);
    }

    generateUrl(url, params = {}) {
        return router.generate('paysera_admin.admin_spa', { url, ...params });
    }

    generateBuyerUrl(url, params = {}) {
        return router.generate('paysera_admin.buyer_spa', { url, ...params });
    }

    getRouteByPathname(pathname) {
        return Object.values(this.routes)
            .map(route => ({
                ...matchPath(pathname, { path: route.path }),
                id: route.id,
            }))
            .find(route => route.isExact);
    }

    getMatchingUrl(pathname, routes) {
        const currentMatch = routes
            .map((route) => {
                const match = matchPath(pathname, { path: route.path });
                if (match !== null) {
                    match.id = route.id;
                }
                return match;
            })
            .find(route => route !== null);
        return (currentMatch && currentMatch.url) ? currentMatch : null;
    }

    getRoutePathMatch(pathname, routeId) {
        return matchPath(pathname, this.findRouteById(routeId).path);
    }

    getRelativeBuyerUrl(id, params, locale) {
        return this.generateBuyerUrl(
            this.generateRouteLink(id, params),
            {
                _locale: locale,
            },
        );
    }
}

export default RouteResolver;
